import React, {useContext} from "react";
import { showInfoToast, showSuccessToast  } from "../../validation/ToastContainer";
import { ScanStatus } from "../../vars";
import { PopupContext } from "../../index";
import { Spinner } from "../../view/Spinner";
import { getConfirmPopup, getClosePopup } from "../../view/popup/PopupContainer";
import * as inventoryService from "./inventoryService";
import {
    finishLocalProcessingTask,
    startLocalProcessingTask
} from "../../processing-tasks/processingTasksRegistry";


function ScanButton({ command, scanStatus, setScanStatus }) {
    
    const { setPopup } = useContext(PopupContext);
    const buttonDisabled = command === "";

    const onConfirm = async (e) => {
        if (buttonDisabled === true) return;
        //e.preventDefault()

        if (command !== "") {
            if (!buttonDisabled) {
                setScanStatus(ScanStatus.PROCESSING);
                const processingTaskId = startLocalProcessingTask({
                    id: `nmap-inventory-${Date.now()}`,
                    type: "Host Discovery",
                    title: "Nmap Host Discovery Scan",
                    target: command,
                    details: command
                });
                showInfoToast('Nmap Host Discovery Scan started', 'Host Discovery');
                return await inventoryService.startNmapInventoryScan(command)
                    .then(() => setScanStatus(ScanStatus.DONE))    
                    .then(() => showSuccessToast('Nmap Host Discovery completed', 'Host Discovery'))
                    .then(() => inventoryService.listPageable(0,10))
                    .finally(() => finishLocalProcessingTask(processingTaskId));
            }
        }  
    }

    const onConfirmScan = () => {
        inventoryService.validateCommandNotChanged(command).then((valid) => 
            {if (valid) {
                setPopup(
                    getConfirmPopup('Are you sure?',
                        'Host Discovery Scan',
                        () => onConfirm()
                    )
                );
            }else {
                setPopup(
                    // getConfirmPopup('Modifying parameters can affect the target system. Exercise caution, especially in production environments. Are you sure?',
                    //     'Host Discovery Scan',
                    //     () => onConfirm()
                    // )
                    getClosePopup('The Subnet Format is not valid. Please rectify it!',
                    'Host Discovery Scan',
                    
                )
                ); 
            }
        }); 
    }

    const showSpinner = scanStatus === ScanStatus.PROCESSING;

    return (     
        <div className={`network-scan-primary-action-v2 ${buttonDisabled && 'is-disabled'}`}
            onClick={buttonDisabled ? null : onConfirmScan}>
            <span className={`${showSpinner && 'spinner-visible'}`}>Host Discovery Scan</span>
            {showSpinner && <Spinner />}
        </div>
    )

}

export default ScanButton;

